export const round = (value: number, decimals: number): number => {
  return +value.toFixed(decimals);
};

export const getOnlyNumberFromString = (value: string): number => {
  const getOnlyNumbers = value.replace(/\D/g, '');
  const getOnlyNumbersAsNumber = parseInt(getOnlyNumbers, 10);
  return getOnlyNumbersAsNumber;
};
